import Vue from 'vue'

const user = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, {
      name,
      welcome
    }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    }
  },

  actions: {
    // 登录
    Login({
      commit
    }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          // const result = response
          // Vue.ls.set(ACCESS_TOKEN, 1111111111111111111111111111, 7 * 24 * 60 * 60 * 1000)
          // commit('SET_TOKEN', result.token)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({
      commit
    }) {
      return new Promise((resolve, reject) => {
        let result = JSON.parse(sessionStorage.getItem('Actions'))
        let Enumerable = require('linq').default
        let list = result.filter(it => {
          return it && it.ActionID !== 0
        })
        let groupList = Enumerable.from(list)
          .groupBy(x => x.ActionID)
          .select(x => ({
            key: x.key(),
            label: x.Title,
            value: x.key(),
            source: x.getSource()
          })).toArray()
        let role = {
          permissions: [],
          permissionList: []
        }
        role.permissions = groupList
        role.permissions.map(per => {
          if (per.source != null && per.source.length > 0) {
            const action = per.source.map(action => {
              return action.PermissionCode
            })
            per.actionList = action
          }
        })
        role.permissionList = role.permissions.map(permission => {
          return permission.key
        })
        commit('SET_ROLES', role)
        resolve(role)
      })
    },
    // 登出
    Logout({
      commit,
      state
    }) {
      return new Promise((resolve) => {
        // logout(state.token).then(() => {
        //   resolve()
        // }).catch(() => {
        //   resolve()
        // }).finally(() => {
        //   commit('SET_TOKEN', '')
        //   commit('SET_ROLES', [])
        //   Vue.ls.remove(ACCESS_TOKEN)
        // })
      })
    }

  }
}

export default user


// WEBPACK FOOTER //
// ./src/store/user.js